import { getParentByClass, addClass, removeClass } from "../helper/helper";

export function initToggleDropdown() {
  const toggleItems = document.querySelectorAll(".dropdown-toggle");

  for (let i = 0; i < toggleItems.length; i++) {
    toggleItems[i].addEventListener("click", function () {
      let toggle = toggleItems[i].getAttribute("aria-expanded");
      let menuItem = getParentByClass(toggleItems[i], "menu-item");

      if (toggle == "true") {
        toggleItems[i].setAttribute("aria-expanded", "false");
        removeClass(menuItem, "menu-expanded");
      } else {
        toggleItems[i].setAttribute("aria-expanded", "true");
        addClass(menuItem, "menu-expanded");
      }
    });
  }
}

export function disableEmptyNavLinks() {
  document
    .querySelectorAll('.menu-item a[href="#"]')
    .forEach(function (element) {
      element.addEventListener("click", function (event) {
        event.preventDefault();
      });
    });
}
